<div class="countdown">
  <ng-container *ngFor="let unit of displayUnits; let i = index">
    <div class="measurements">
      <div class="measurements-number">
        <ng-container *ngFor="let unitNumber of unit.unitNumbers; let j = index">
          <div class="countdown-number">
            {{unitNumber}}
          </div>
        </ng-container>
        <span *ngIf="displayUnits[i+1]" class="divider"> {{divider}} </span>
      </div>
      <div class="measurements-text">
        <span>
          {{unit.name}}
        </span>
      </div>
    </div>
  </ng-container>
</div>